/**
 * A hook to obtain home page data.
 *
 * @module
 */
import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
/**
 *
 * # useHomePageData
 *
 * Example usage:
 * ```javascript
 * const MyHomePage: React.FC = () => {
 *   const { fetchingStatus, data } = useHomePageData();
 *
 *   if (fetchingStatus === 'is-fetching' || fetchingStatus === 'not-started')
 *     return <div className="loading" />;
 *   if (fetchingStatus === 'LoginRequired')
 *     return <div className="error-401-page">Login required</div>;
 *   if (fetchingStatus !== 'has-fetched' || !data)
 *     return <div className="error-page">There was an error.</div>;
 *
 *   return (
 *     <div>
 *       Welcome home. Here is a list of your categories:
 *       <ul>
 *         {data.categories.map((category) => {
 *           <li key={category.id}>{category.title}</li>;
 *         })}
 *       </ul>
 *     </div>
 *   );
 * };
 * ```
 */
export default function useHomePageData() {
    const fetchingStatus = useSelector((state) => selectors.homePageFetchingStatus(state));
    const data = useSelector((state) => selectors.getHomePageData(state));
    return {
        fetchingStatus,
        data,
    };
}
//# sourceMappingURL=useHomePageData.js.map